import { render, staticRenderFns } from "./ImpedidosDeContratar.vue?vue&type=template&id=7fc96ba5"
import script from "./ImpedidosDeContratar.vue?vue&type=script&lang=ts"
export * from "./ImpedidosDeContratar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports